export default __webpack_public_path__ + "static/media/002-pagoda.8d36cb00.svg";